import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ILabels } from "libraries/interfaces/ILabels";
import { IAirRating } from "libraries/model/air-quote/IQuote";

@Component({
    selector: 'yucangoo-rating',
    template: `
        <ng-container *ngIf="rating">
            <div>
                <img [attr.src]="imgSrc"
                     [attr.alt]="wording.title"
                     [attr.title]="wording.title">
            </div>
            <div>
                <rating-notation [rating]="rating"
                    [showAverage]="showAverage"
                    [averageLabel]="averageLabel"
                    [referenceRating]="referenceRating"
                    [small]="false"
                    [showShape]="showShape"></rating-notation>
            </div>
        </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class YucangooRatingComponent {
    @Input()
    public rating: IAirRating;
    @Input()
    public referenceRating: IAirRating;
    @Input()
    public showAverage: boolean = true;
    @Input()
    public showShape: boolean = true;
    @Input()
    public averageLabel: string;
    @Input()
    public imgSrc: string = "static/yucangoo_logo.png";

    public wording: ILabels = {
        title: 'YUCANGoo'
    };

}
